// Utility to get a browser/device fingerprint using FingerprintJS
// https://www.npmjs.com/package/@fingerprintjs/fingerprintjs
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export async function getFingerprintId() {
  let fp = window.localStorage.getItem("deviceFingerprintId");
  if (!fp) {
    const fpInstance = await FingerprintJS.load();
    const result = await fpInstance.get();
    fp = result.visitorId;
    window.localStorage.setItem("deviceFingerprintId", fp);
  }
  return fp;
}
